<template>
  <div>
    <button
        v-on:click="showModal"
        :class="btnTheme"
    >
    {{  btnName }}
        </button>
    <div v-if="showConfirm" class="modal-mask" @click="closeModal">
      <div class="modal-wrapper" @click.stop>
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              {{ header }}
              <span class="pull-right" @click="closeModal" style="cursor:pointer;">x</span>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div>
                <p>Please select a dealing rep for investment with id: {{ investmentId }}.</p>
                <select class="form-control" v-model="postData.dealingRepId">
                  <option v-for="rep in sortedReps" :value="rep.id" v-if="rep.is_disabled != 1 && rep.pivot.status == 1">
                    {{ rep.full_name }}
                  </option>

                </select>

              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button
                  type="button"
                  @click.prevent="closeModal"
                  class="modal-default-button btn btn-secondary pull-left"
              >
                Cancel
              </button>
              <button
                  type="button"
                  @click.prevent="updateDealingRep"
                  class="modal-default-button btn btn-primary"
              >
                Update Dealing Rep
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmModal from "./ConfirmModal";
import axios from "axios";

export default {
  name: "ConsoleChangeDRModal",
  components: {ConfirmModal},
  props: {
    header: {
      required: true
    },
    investmentId: {
      required: true
    },
    dealingReps: {
      type: Array
    },
    btnName: String,
  },
  data() {
    return {
      showConfirm: false,
      btnTheme: 'btn btn-default btn-xs',
      postData: {
        investmentId: this.investmentId,
        dealingRepId: 0,
      },
      alertMessage: "",
    }
  },
  computed: {
    sortedReps() {
      return this.dealingReps.sort(function(a,b) {
        let x = a.full_name.toLowerCase()
        let y = b.full_name.toLowerCase()
        if(x<y) return -1
        if(x>y) return 1
        return 0
      })
    }
  },
  methods: {
    showModal() {
      this.showConfirm = true
    },
    closeModal() {
      this.showConfirm = false
    },
    updateDealingRep() {
      axios.post('subscriptions/changedr',this.postData)
          .then(response => {
            this.alertMessage = response.data.status
            return Promise.resolve()
          }).catch()
      this.closeModal()
      window.location.href = "console"
    }
  }
}
</script>